export const environment = {
  production: true,
  firebaseConfig: {
    apiKey: "AIzaSyAPu1LTKCPWRixBDkhTzy942qwoKrvKk2E",
    authDomain: "mnd-noumo.firebaseapp.com",
    projectId: "mnd-noumo",
    storageBucket: "mnd-noumo.appspot.com",
    messagingSenderId: "636900980642",
    appId: "1:636900980642:web:4872e16ba7d6eee19464fb"
  }
};
